import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
// import dummData from './start_data.json';
// import dummData from './junior_data.json';
// import dummData from './one_data.json';

const INITIAL_VALUES = {};

const DataContext = createContext(INITIAL_VALUES);

const isJsonValue = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const DataProvider = props => {
  const { children, id, campaignAccessKey, initial, grades } = props;
  const [state, setState] = useState(initial || INITIAL_VALUES);
  const [campaign, setCampaign] = useState(null);
  const [responses, setResponses] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log('on data context results');
    const getRespData = async () => {
      const POST_API = `/api/campaign`;
      const body = {
        params: {
          id,
          accessKey: campaignAccessKey
        }
      };
      // console.log('prev calling');
      // const options = { ...opts, headers };
      // console.log({ body, options });
      const { data } = await axios.get(POST_API, body);
      // const data = dummData;
      // console.log({ data });
      if (data) {
        const campaignData = data.campaign;
        if (campaignData.participants) {
          campaignData.participants = isJsonValue(data.campaign.participants)
            ? JSON.parse(data.campaign.participants)
            : data.campaign.participants;
        }
        if (campaignData.metadata) {
          campaignData.metadata = isJsonValue(data.campaign.metadata)
            ? JSON.parse(data.campaign.metadata)
            : data.campaign.metadata;
        }
        try {
          // const parsed = JSON.parse(data);
          const finishedResponses = data.responses.filter(
            resp => resp.submitted
          );
          const campaignResponses = finishedResponses.map(resp => {
            return {
              ...resp,
              data:
                typeof resp.data === 'string'
                  ? JSON.parse(resp.data)
                  : resp.data
            };
          });
          const gradeFilters = grades || [];
          const filteredGradeResponses = campaignResponses.filter(resp => {
            if (gradeFilters.length === 0) return true;
            const respGrade = resp.data?.grade;
            // console.log({ respGrade });
            return gradeFilters.includes(respGrade);
          });

          await setCampaign(campaignData);
          await setResponses(filteredGradeResponses);
        } catch (err) {
          console.log(err);
          await setCampaign(null);
        }
      }
      await setLoading(false);
    };
    getRespData();
  }, [id, campaignAccessKey]);

  return (
    <DataContext.Provider
      value={{
        ...state,
        updateContext: setState,
        campaign,
        responses,
        grades,
        isLoading: loading
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const DataConsumer = DataContext.Consumer;
export const useDataContext = () => useContext(DataContext);
